import React, { useEffect, useRef } from "react";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import { ActionButton, checkImage, ToggleSwitch } from "../../../helper/ImageFormat";
import dateformate from "../../../helper/DateFormate";

const CurrencyTable = ({
  loading,
  currencies,
  currentPage,
  perPage,
  handleEditClick,
  handleDelete,
  handleStatusToggle,
  totalCount,
  totalPages,
  handlePageClick,
  selected,
  setSelected,
  columnsList,
}) => {
  const selectAllRef = useRef(null);
  const isAllSelected = currencies.length > 0 && selected.length === currencies.length;
  const isIndeterminate = selected.length > 0 && selected.length < currencies.length;

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  const toggleSelectAll = () => {
    setSelected(isAllSelected ? [] : currencies.map((b) => b.id));
  };

  const toggleSelectOne = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  return (
    <div className="row">
      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="custom-table table table-striped">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        ref={selectAllRef}
                        checked={isAllSelected}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    {columnsList.map(
                      (col) =>
                        col.visible && <th key={col.key}>{col.label}</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Spinner />
                      </td>
                    </tr>
                  ) : currencies.length > 0 ? (
                    currencies.map((currency, id) => (
                      <tr key={currency.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selected.includes(currency.id)}
                            onChange={() => toggleSelectOne(currency.id)}
                          />
                        </td>
                        {columnsList.map(
                          (col) =>
                            col.visible && (
                              <td key={col.key}>
                                {col.key === "code" && currency.code}
                                {col.key === "symbol" && currency.symbol}
                                {col.key === "rate" &&
                                  currency.rate.toFixed(2)}
                                {col.key === "flag" &&
                                  checkImage(currency.flag)}
                                {col.key === "isActive" && (
                                  <ToggleSwitch
                                    data={currency}
                                    name="isActive"
                                    checked={currency.isActive}
                                    handleStatusToggle={handleStatusToggle}
                                    module={"Currency"}
                                  />
                                )}
                                {col.key === "updatedAt" && (
                                  <span title={currency.updatedAt}>
                                    {dateformate(currency.updatedAt)}
                                  </span>
                                )}
                                {col.key === "createdAt" && (
                                  <span title={currency.createdAt}>
                                    {dateformate(currency.createdAt)}
                                  </span>
                                )}
                                {col.key === "actions" && (
                                  <ActionButton
                                    data={currency}
                                    handleEditClick={handleEditClick}
                                    handleDelete={handleDelete}
                                    module={"Currency"}
                                  />
                                )}
                              </td>
                            )
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <h4>No data available</h4>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {currencies?.length > 0 && (
              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageClick}
                perPage={perPage}
                totalCount={totalCount}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyTable;
